import { useState } from 'react';
import PropTypes from 'prop-types';
import './SearchInput.css';

const closeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const SearchInput = ({
  id,
  disabled = false,
  value = '',
  placeholderValue = '',
  charLimit = null,
  onChange = () => {},
  onFocus = () => {},
  onClearClick = () => {},
}) => {
  const [isActive, setIsActive] = useState(false);

  const handleFocus = () => {
    setIsActive(true);
    onFocus();
  };

  const handleChange = (newValue) => {
    // If charLimit is set, enforce the limit
    if (charLimit !== null && newValue.length > charLimit) {
      return; // Don't update if over limit
    }
    onChange(newValue);
  };

  return (
    <div className={`search-input ${(isActive) ? 'active' : ''}`}>
      <input
        id={id}
        className={`${(disabled) ? 'disabled' : ''} ${(value) ? 'has-value' : ''}`}
        disabled={disabled}
        type="text"
        value={value}
        placeholder={placeholderValue}
        onChange={(e) => handleChange(e.target.value)}
        onFocus={handleFocus}
        onBlur={() => setIsActive(false)}
      />
      <ion-icon name="search" />
      {
        value && !disabled && (
          <div className="search-input-cancel" onClick={onClearClick}>
            {closeIcon}
          </div>
        )
      }
    </div>
  );
};

SearchInput.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  placeholderValue: PropTypes.string,
  charLimit: (props, propName, componentName) => {
    const value = props[propName];
    if (value === null || value === undefined) {
      return null; // null/undefined is allowed
    }
    if (typeof value !== 'number') {
      return new Error(
        `Invalid prop \`${propName}\` of type \`${typeof value}\` supplied to \`${componentName}\`, expected \`number\` or \`null\`.`,
      );
    }
    if (!Number.isInteger(value) || value <= 0) {
      return new Error(
        `Invalid prop \`${propName}\` of value \`${value}\` supplied to \`${componentName}\`, expected a positive integer or \`null\`.`,
      );
    }
    return null;
  },
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onClearClick: PropTypes.func,
};

export default SearchInput;
